import { render, staticRenderFns } from "./kpis-table.vue?vue&type=template&id=76521388&scoped=true"
import script from "./kpis-table.vue?vue&type=script&lang=js"
export * from "./kpis-table.vue?vue&type=script&lang=js"
import style0 from "./kpis-table.vue?vue&type=style&index=0&id=76521388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76521388",
  null
  
)

export default component.exports